module.exports = __webpack_public_path__ + "static/media/Zorua_gaussian2.4d2d0165.png";